import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-nightmarket.webp"
            alt="Nightmarket"
          />
        </p>
        <strong>
          The trade center for exotic goods imported by rail. Many vendors also
          trade in illicit goods.
        </strong>{" "}
        <em>
          Nightmarket is a district dominated by <strong>commerce</strong>.
          Situated near <strong>Gaddoc Rail Station</strong>, Nightmarket
          receives the bulk of salable goods from the cargo trains that travel
          across the Imperium, bringing the exotic and rare to Duskwall. The
          citizens that call Nightmarket home constitute a new class of{" "}
          <strong>“elites”—wealthy people who are not of noble descent</strong>{" "}
          but nevertheless claim land, status, and power without titles. The
          district has been taken over by <strong>new construction</strong>,
          introducing <strong>lavish private townhouses</strong> with all of the
          modern advances for the elites that can afford them.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-nightmarket.webp"
          alt="Nightmarket"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Scene:</strong> Electric lights in a riot of colors
                advertise the market stalls of the vendors. Several devout
                acolytes bow in silent prayer at the statues of the Night Queen,
                the district’s adopted forgotten god. The city’s elite, hidden
                behind masks, slip into the underground to partake of strange
                pleasures in the private clubs.
                <br />
                <strong>Streets:</strong> Multi-level wooden platforms and
                boardwalks. Landscaped parks of petrified trees from the
                deathlands. High-class subterranean avenues.
                <br />
                <em>Song Street, String Street, Paper Street, Bell Street.</em>
                <br />
                <strong>Buildings:</strong> Wooden market stalls. Underground
                stone shops and clubs. Newly constructed private townhouses for
                the Nightmarket elites.
                <br />
                <strong>Factions:</strong>
                <ul>
                  <li>1. The Dimmer Sisters</li>
                  <li>2. The Path of Echoes</li>
                  <li>3. Deathland Scavengers</li>
                  <li>4. The Wraiths</li>
                  <li>5. Imperial Military</li>
                  <li>6. Ministry of Preservation</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-nightmarket.webp"
                  alt="Nightmarket district traits"
                />
                <br />
                <br />
                <em>
                  Nightmarket is the best place to trade illicit and arcane
                  goods in the city, but the darker corners are full of strange
                  horrors. You can take <strong>+1d</strong> to acquire an asset
                  here, at the cost of <strong>2 stress</strong>.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Nightmarket Locations</h1>
        <strong>
          <u>The Devil&apos;s Tooth</u>
        </strong>
        : A tavern known for its “secret” menu of alchemical concoctions.
        Adventurous psychonauts may experiment with all manner of mind-altering
        (or spirit-altering) substances in the relative safety of Mistress
        Kember’s comfortable establishment.
        <br />
        <br />
        <strong>
          <u>Dunbridge &amp; Sons</u>
        </strong>
        : Considered by many to be the <strong>foremost tailor</strong> in
        Duskwall. The Dundridge family has provided the finest clothes and
        sartorial accoutrements to discerning citizens for over 300 years out of
        the Nightmarket district. Despite their legendary reputation,
        Dundridge&apos;s <strong>prices are very reasonable</strong>.
        <br />
        <br />
        <strong>
          <u>The Veil</u>
        </strong>
        : A luxurious social club known for its confidentiality and permissive
        policies regarding guests of arcane or unusual origins. Rolan Volaris,
        the proprietor and host, is a Tycherosi with an extremely unusual
        manifestation of his demonic blood: rather than legs, he has the body of
        a serpent from the waist down... or so people say. Volaris is rarely
        seen in person.
        <br />
        <br />
        <strong>
          <u>Vreen&apos;s Hound Races</u>
        </strong>
        : The racing of specially bred hounds is currently in vogue among
        Doskvol’s upper crust. A con man from the Dagger Isles calling himself
        “Master Vreen” swindled a small fortune from gullible investors to
        create “the premier hound racing track in the Imperium.” The investors
        have yet to see any returns, but Vreen assures them that a great
        windfall is due any day now.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Nightmarket = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <div
                    class="bitdFont morkBorgText"
                    style={{ textAlign: "center" }}
                  >
                    💀{" "}
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-introduction"
                    >
                      Introduction
                    </a>{" "}
                    💀
                    <a
                      style={{ color: "yellow" }}
                      href="./blades-in-the-dark-campaign-districts"
                    >
                      Districts
                    </a>{" "}
                    💀
                  </div>
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Nightmarket;
